import '../../styles/argox-logo.css';

export function ArgoxLogo({ className = '' }: { className?: string }) {
  return <svg className={`argox-wordmark ${className}`.trim()} viewBox="0 0 660 220" role="img" aria-label="Argox">
    <g fill="currentColor" fontFamily="Arial Rounded MT Bold, Arial Rounded Bold, Arial, sans-serif" fontSize="190" fontWeight="700"><text x="12" y="174" textLength="472" lengthAdjust="spacingAndGlyphs">argo</text></g>
    <g fill="none" stroke="currentColor" strokeWidth="28" strokeLinecap="round"><path d="m540 99-34-34"/><path d="m562 99 34-34"/><path d="m540 121-34 34"/><path d="m562 121 34 34"/></g>
    <circle cx="551" cy="110" r="20" fill="#fff"/><circle cx="551" cy="110" r="12" fill="#ffbd2e"/>
  </svg>;
}
